var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('CTableWrapper',{attrs:{"items":_vm.trafficSources,"is-loading":_vm.isLoading,"small":"","border":"","sorter":"","fields":_vm.fields,"type":"TrafficSource","icon":"cil-tags","caption":"TrafficSources","sorter-value":{ column: 'name', asc: true },"column-filter":""}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }